import { shouldBounceOn401, EXPIRED_ROUTE } from '~/composables/useVdrParticipant401'

// Spec §8: global client interceptor. On any /api/vdr/* 401 (participant
// DEACTIVATED mid-session) redirect to the expired/magic-link screen. Uses the pure
// shouldBounceOn401 predicate (unit-tested) so this plugin stays a thin wiring shell.
export default defineNuxtPlugin(() => {
  globalThis.$fetch = $fetch.create({
    onResponseError({ request, response }) {
      const url = typeof request === 'string' ? request : request.url
      if (shouldBounceOn401(response.status, url)) {
        // Hard navigation: full SPA reset so no stale participant state survives.
        window.location.assign(EXPIRED_ROUTE)
      }
    },
  })
})
